<announcekit [widget]="announceKitUrl" [labels]="labels" [user]="userData$ | async" [data]="segmentData$ | async">
  <mat-icon>notifications</mat-icon>
</announcekit>
